import { environment } from "src/environments/environment";

export class User {
  public email: string;
  public uid: string;

  constructor(email: string, uid: string) {
    this.email = email;
    this.uid = uid;
  }

  get isAdmin(): boolean {
    return this.uid === environment.adminUid;
  }
}
